import { render, staticRenderFns } from "./news-and-media-config.vue?vue&type=template&id=748ceb48&scoped=true"
import script from "./news-and-media-config.vue?vue&type=script&lang=js"
export * from "./news-and-media-config.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "748ceb48",
  null
  
)

export default component.exports